import { useNavigate, useParams } from 'react-router';
import { useMemo } from 'react';
import { useSpeciesData } from './hooks/useSpeciesData';
import WizardWrapper from './WizardWrapper';
import { stringify } from '@/utils/miscUtils';
import MEBalanceInputs from './MEBalanceInputs';
import TeaInputs from './TeaInputs';

const steps = [
  { id: 'meBalance', label: 'Part 1: Mass and Energy Balance', Component: MEBalanceInputs },
  { id: 'tea', label: 'Part 2: TEA', Component: TeaInputs },
];

const CreateModelModal = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { typeOptions, typeToUnitsMap, isLoading } = useSpeciesData();

  const defaultValues = useMemo(() => {
    const defaultType = typeOptions?.[0]?.value ?? '';
    const defaultUnit = typeToUnitsMap?.[defaultType]?.[0];

    return {
      label: '',
      description: '',
      permissions: 'creator',
      inputs: [
        {
          label: 'Option 1',
          name: 'input_1',
          species: defaultType,
          value: '',
          unit: stringify(defaultUnit),
        },
      ],
      outputs: [
        {
          label: 'Option 1',
          name: 'output_1',
          species: defaultType,
          value: '',
          unit: stringify(defaultUnit),
          allocatable: true,
          emissions: false,
        },
      ],
      tea_type: 'simple',
      simpleCosts: {
        spec_type: 'process_only',
        levelized_costs: [],
      },
      bottomUpCosts: {
        reference_product: '',
      },
    };
  }, [typeOptions, typeToUnitsMap]);

  const handleClose = () => {
    const { pathwayId, projectId, caseId } = params;
    navigate(`/projects/${projectId}/build/pathways/${pathwayId}/${caseId}`, { replace: true });
  };

  return (
    <dialog className="modal bg-gray-900/30" open>
      <div className="modal-box w-[95vw] h-[90vh] max-h-[90vh] max-w-[1400px] p-0 flex flex-col border border-gray-200 shadow-2xl">
        <button
          type="button"
          className="btn btn-sm btn-circle btn-ghost absolute right-4 top-4 z-10"
          onClick={handleClose}
        >
          ✕
        </button>
        <WizardWrapper
          title="Create a Ratio Module"
          subtitle="Fixed input and output amounts that scale linearly with your pathway."
          guideUrl="https://docs.sesame.software/user-guides/pathways/modules/adding-a-custom-module.html#ratio-module"
          defaultValues={defaultValues}
          isLoading={isLoading}
          typeOptions={typeOptions}
          typeToUnitsMap={typeToUnitsMap}
          steps={steps}
          onSaved={handleClose}
        />
      </div>
    </dialog>
  );
};

export default CreateModelModal;
